import { FormElement, Select } from 'mailup-web-components'
import { workflowCommonDataState } from 'Pages/Workflow/recoil/state/data'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const InputClickedLink = () => {
  const intl = useIntl()

  const { ClickedLink } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const { emailMessageLinks } = useRecoilValue(workflowCommonDataState)

  const [isDirty, setIsDirty] = useState(false)

  const emailMessageLinksOptions = useMemo(() => {
    return [
      {
        value: '',
        label: intl.formatMessage({
          id: 'Load.AutomationWorkflow.ActivityMessagesLinkPlaceholder'
        })
      },
      ...emailMessageLinks.map((url) => ({
        label: url,
        value: url
      }))
    ]
  }, [emailMessageLinks])

  const handleLinkChange = (value) => {
    setWorkflowDetailsState((prev) => ({ ...prev, ClickedLink: value }))
    setIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const invalid = isDirty && ClickedLink === undefined

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.MailupCommon.Link'
      })}
      feedback={invalid ? requiredFeedback : undefined}
      variant={invalid ? 'danger' : undefined}
    >
      <Select
        value={ClickedLink}
        options={emailMessageLinksOptions}
        onChange={handleLinkChange}
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.SelectLinkPlaceholder'
        })}
        error={invalid}
      />
    </FormElement>
  )
}

export default InputClickedLink
